function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  d: "M20.473 18.91A7.696 7.696 0 0017.46 7.29a8.795 8.795 0 10-15.6 6.915L.332 15.722A1.1 1.1 0 00.1 16.921a1.1 1.1 0 001.011.681h6.256A7.696 7.696 0 0014.305 22h6.596a1.1 1.1 0 001.012-.682 1.1 1.1 0 00-.231-1.198l-1.21-1.21zM6.609 14.305c.002.368.031.736.088 1.1H3.762l.385-.374a1.1 1.1 0 000-1.562 6.52 6.52 0 01-1.935-4.661A6.597 6.597 0 018.808 2.21a6.53 6.53 0 016.212 4.398h-.715a7.696 7.696 0 00-7.696 7.696zm11.588 5.497l.055.055h-3.947a5.497 5.497 0 113.892-1.605 1.1 1.1 0 00-.33.77 1.1 1.1 0 00.33.78z",
  fill: "currentColor",
  fillRule: "evenodd"
})));